// Dados da empresa usados nas páginas legais e no rodapé.
export const COMPANY = {
  name: 'PlusPlus',
  email: 'andre@plusplus.com.br',
  street: 'Rua Vitória Regia, 64',
  district: 'Nilson Neves',
  city: 'Paranaguá',
  state: 'PR',
  zip: '83215-540',
  whatsapp: '(41) 3180-0650',
};
// Preencha as URLs para os ícones aparecerem no rodapé (vazio = oculto).
export const SOCIAL = { instagram: '', facebook: '', youtube: '' };
export const UPDATED_AT = '28 de setembro de 2026';
export const addressLine = () =>
  `${COMPANY.street}, ${COMPANY.district}, ${COMPANY.city} - ${COMPANY.state}, CEP ${COMPANY.zip}`;
